import { getLatestData } from '../Utils/GetLatestData'
import { WizardContext, WizardEvent } from '../wizardMachine'

export const isAssetSales = (context: WizardContext, event: WizardEvent): boolean => {
  const { asset } = getLatestData(context, event)
  if (asset) {
    if (asset.is_sale === true) {
      return true
    }
  }

  return false
}
